/** All of available expired informer item types. Defines a specific entity type. */
export enum ExpiredInformerItemTypeEnum {
  /** BRS task */
  BRS_TASK = 'BRS_TASK',
  /** HelpDesk task */
  HD_TASK = 'HD_TASK',
  /** Project */
  PROJECT = 'PROJECT',
}
